import React from 'react'
import SewingGroupPage from './SewingGroupPage'
import '../styles/index.scss'

const SewingGroupContainer = () => {
    return (
        <div className="SewingGroupContainer p-5">
            <div className='row'>
                <div className='col-12 mx-auto'>
                    <div className="d-flex align-items-baseline justify-content-between">
                        <h1 className="PageTitle">Giao nhóm may</h1>
                    </div>
                    <div className="site-layout-background">
                        <SewingGroupPage />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SewingGroupContainer